export default __webpack_public_path__ + "static/media/Reloj.9af6c482.svg";